<template>
  <div class="youtube-wrapper">
    <iframe :src="src" frameborder="0" allowfullscreen></iframe>
  </div>
</template>

<script>

import { getYoutubeSrcIDFromLink } from '@/utils'

export default {
  name: 'YoutubeBlock',
  props: ['content'],
  computed: {
    src () {
      const id = getYoutubeSrcIDFromLink(this.content.attrs.src)
      return `https://www.youtube.com/embed/${id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.youtube-wrapper {
  width: 100%;
  margin-bottom: 1rem;

  iframe {
    width: 100%;
    height: 177px;

    @include tablet {
      height: 390px;
    }

    @include desktop {
      height: 376px;
    }

    @include desktop-lg {
      height: 376px;
    }
  }
}
</style>
